import { render, staticRenderFns } from "./ConfiguratorBanner.vue?vue&type=template&id=2e39d392&scoped=true"
import script from "./ConfiguratorBanner.vue?vue&type=script&lang=ts"
export * from "./ConfiguratorBanner.vue?vue&type=script&lang=ts"
import style0 from "./ConfiguratorBanner.vue?vue&type=style&index=0&id=2e39d392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39d392",
  null
  
)

export default component.exports